import React, { Component } from 'react'

// Local (2026-header-scoped) version of ../containers/shared/ResizeContainer.
// Thresholds are aligned to the 2026 design-token breakpoints
// (see src/design-tokens/responsive/breakpoints.css /
// src/assets/css/gamification2026/_utils.scss) so the banner image swap
// happens exactly when the CSS layout reflows (740px tablet, 1280px small
// desktop) instead of the legacy, unrelated 550px/800px thresholds.
class LocalResizeContainer extends Component {
  state = {
    imageSize: 'extra_desktop_image',
    limitText: 400
  }

  resize = () => {
    let newLimitText = 400

    let bannerImage = 'extra_desktop_image'
    if (window.innerWidth > 1440) {
      bannerImage = 'extra_desktop_image'
    }
    else if (window.innerWidth >= 1280 && window.innerWidth <= 1440) {
      bannerImage = 'desktop_image'
      if (window.innerWidth <= 1280) {
        newLimitText = 100
      }
    }
    else if (window.innerWidth >= 740 && window.innerWidth < 1280) {
      bannerImage = 'tablet_image'
      newLimitText = 60
    }
    else if (window.innerWidth < 740) {
      bannerImage = 'mobile_image'
    }
    this.setState({
      imageSize: bannerImage,
      limitText: newLimitText
    })
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize)
    this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resize)
  }

  render() {
    const { component: Component, ...rest } = this.props
    return (
      <Component {...rest}
        imageSize={this.state.imageSize}
        limitText={this.state.limitText}
      />
    )
  }
}

const Container = LocalResizeContainer

export function withLocalResizeContainer(component) {
  return (props) => (
    <Container
      component={component}
      {...props}
    />
  )
}

export default Container
